import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const createUser = (name) => api.post("/users", { name }).then((r) => r.data);
export const getUser = (id) => api.get(`/users/${id}`).then((r) => r.data);
export const getProgress = (id) => api.get(`/progress/${id}`).then((r) => r.data);
export const updateProgress = (id, payload) =>
  api.put(`/progress/${id}`, payload).then((r) => r.data);

export const sendCertificateEmail = (userId, recipientEmail, pdfBase64) =>
  api
    .post("/send-certificate", {
      user_id: userId,
      recipient_email: recipientEmail,
      pdf_base64: pdfBase64,
    })
    .then((r) => r.data);
